__turbopack_context__.v({
  "freeBox": "PlasmicDescription-module__Q-sd9G__freeBox",
  "root": "PlasmicDescription-module__Q-sd9G__root",
});
